import gql from 'graphql-tag';

const PENDING_STOCK_LIST_FRAGMENT = gql`
	fragment pendingStockListItem on PendingStock {
		id
		created
		status
		sourceType
		reasonType
		note
		quantity
		originalQuantity
		expiryDate
		batchExpiryDates
		expiryPolicyContext
		resolvedAt
		product {
			id
			name
			imageUrl
			caseSize
			shipperSize
			palletSize
			forceQuantityInUnits
			isFreshFood
			expiryDatePolicy
		}
		warehouse {
			id
			name
		}
		warehouseProduct {
			id
			quantity
			product {
				id
				caseSize
				shipperSize
				palletSize
				forceQuantityInUnits
				isFreshFood
				expiryDatePolicy
			}
		}
		machine {
			id
			assetId
		}
		serviceRun {
			id
			name
			planned
			driver {
				id
				firstname
				lastname
				username
			}
			route {
				id
				name
			}
		}
		stockDelivery {
			id
			identifier
		}
		stockDeliveryItem {
			id
			deliveredAt
			receivedAt
			expiryCaptureRequired
		}
	}
`;

export const GET_PENDING_STOCK_LIST = gql`
	query getPendingStocks(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int,
		$filter: PendingStockPageFilter,
	) {
		getPendingStocks(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...pendingStockListItem
			}
			count
		}
	}
	${PENDING_STOCK_LIST_FRAGMENT}
`;

export const GET_PENDING_STOCKS_COUNT = gql`
	query (
		$filter: PendingStockCountFilter
	) {
		countPendingStocks(
			filter: $filter,
		)
	}
`;
